import React from 'react';
import styles from './Components.module.css';

import { Modal } from 'antd';
import { useSelector, useDispatch } from 'react-redux';
import { IState } from '../graphql/types';
import { setUpgradeModalOpen } from '../actions';

import DetailedUpgradeView from './Upgrade/DetailedUpgradeView';

const UpgradeModal: React.FC<{}> = () => {
  const dispatch = useDispatch();
  const upgradeModalOpen = useSelector<IState, boolean>(
    state => state.upgradeModalOpen
  );

  return (
    <Modal
      closable
      destroyOnClose
      open={upgradeModalOpen}
      onCancel={() => dispatch(setUpgradeModalOpen(false))}
      footer={null}
      width={'fit-content'}
      styles={{ body: { padding: '0', borderRadius: 24 } }}
      className={styles.upgradeModalWrap}
    >
      <DetailedUpgradeView />
    </Modal>
  );
};

export default UpgradeModal;
